import DomManipulate from "./DomManipulate";

const popupDelay = 250 //ms
const animationTime = 500 //ms

export class OffCanvaMenu {

  constructor(selector, changeCallback = null, resetCallback = null, desktopCallback = null) {
    this.selector = selector;
    this.collapseStatus = 1; //1 = open; 0 = closed

    //Swipe vars
    this.startX;
    this.startY;
    this.dist;
    this.threshold = -100; //required min distance traveled to be considered swipe
    this.allowedTime = 100; // maximum time allowed to travel that distance
    this.elapsedTime;
    this.startTime;

    //Input change callback
    this.changeCallback = changeCallback;

    //Reset resetCallback
    this.resetCallback = resetCallback;

    //Desktop trigger callback
    this.desktopCallback = desktopCallback;
  }

  init() {
    const dom = new DomManipulate();

    dom.onReady(() => {
      let that = this;
      this.initToggleAll();

      setTimeout(function (){
        $('.js-select2').each(function(){
          $(this).select2({ dropdownParent: $('.search-bottom') })
            .on('select2-open', function(){
              $('.select2-search input, :focus,input').prop('focus',false).blur();
            })
            .on('select2-open', function(){
              $('.select2-search input, :focus,input').prop('focus',false).blur();
            });
        });
      }, 100);

      if($( window ).width() < 1281) {
        $(that.selector).removeClass('desktop-collapse');
      }

      setTimeout(function (){
        $('.js-toggle-overlay').addClass('slide-in');
        that.setEventHandlers();
        that.setSwipeEvent();
      }, popupDelay);

      if(typeof that.desktopCallback == "function")
        that.desktopCallback();
    });
  }

  setEventHandlers(){
    let that = this;

    $(this.selector +' .form-control').on('change', function() {
      setTimeout(function (){
        if(that.changeCallback != null){
          that.changeCallback();
        }
      }, 1000)
    });

    //Reset All
    $(this.selector).find('.js-search-reset').on('click', function(){
      that.resetAll();

      if(that.resetCallback != null){
        that.resetCallback();
      }

      if(that.changeCallback != null){
        that.changeCallback();
      }
    });

    //Open
    $(this.selector).find('.js-toggle-overlay').on('click', function(){
      that.open();
    });

    //Close
    $(this.selector).find('.js-close-overlay').on('click', function(){
      that.close();
    });
    $(this.selector).find('.js-menu-backdrop').on('click', function(){
      that.close();
    });

    $(this.selector).find('.js-search-collapse').on('click', function(){
      that.toggleAll();
    });

    //Desktop toggle
    $('.js-desktop-toggle').on('click', function(){

      if($(that.selector).hasClass('desktop-collapse')){
        that.desktopOpen();
      }else{
        that.desktopClose();
      }

      if(that.desktopCallback != null){
        setTimeout(function(){
          that.desktopCallback();
        }, 500);
      }
    });


    //Collapse
    $(this.selector+' .collapse_item').each(function(){
      $(this).on('click', function(){
        setTimeout(function (){
          that.toggleOne();
        }, 250);
      })
    });

    //Dynamic adaptation
    $(window).on('resize', function(){

      if($( window ).width() >= 1281){
        $(that.selector).removeClass('offcanvas-show');
      }else{

        that.desktopOpen();

        if( $(that.selector).attr('data-status') == "on" ){
          $(that.selector).find('.js-toggle-overlay').trigger('click');
        }
      }
    });

    //Autohide scrollbar when not moving
    $('.search-scroll').on('scroll', function(){
      $(this).addClass('scrolling');
      let that = this;
      setTimeout(function(){
        $(that).removeClass('scrolling');
      },3000)
    })
  }

  setSwipeEvent() {

    let element = $(this.selector);
    let that = this;

    element.on('touchstart', function(e){
      let touchobj = e.changedTouches[0];

      that.dist = 0;
      that.startX = touchobj.pageX;
      that.startY = touchobj.pageY;
      that.startTime = new Date().getTime(); // record time when finger first makes contact with surface
    });

    element.on('touchend', function(e){

      let touchobj = e.changedTouches[0];

      //Get total dist traveled by finger while in contact with surface
      that.dist = touchobj.pageX - that.startX;

      //Get time elapsed
      that.elapsedTime = new Date().getTime() - that.startTime;

      //Check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100

      let swiperightBol = (that.elapsedTime <= that.allowedTime && that.dist <= that.threshold && Math.abs(touchobj.pageY - that.startY) <= 100);

      if(swiperightBol){
        that.close();
      }
    });
  }

  open(){

    /*
    todo - create a lock to prevent very fast open clsoe
    //Prevents user to click on load not complete
     */
    $(this.selector).attr('data-status', 'on');
    $(this.selector).addClass('offcanvas-show').css('background-color', 'rgba(33, 37, 41, 0.8)');

    $(this.selector).find('.js-toggle-overlay').removeClass('slide-in').addClass('slide-out'); //Close toggle
    $(this.selector).find('.js-menu-overlay').removeClass('slide-out').addClass('slide-in'); //Open dialog

    if ( !document.querySelector('html').classList.contains('cart-opened')) {
      document.querySelector('html').classList.add('cart-opened')
    }

    let that = this;
    $(document).on("keydown.overlay", function(event) {
      const key = event.key;
      if (key === "Escape") {
        that.close();
      }
    });
  }

  close(){
    $(this.selector).attr('data-status', 'off');
    $(document).off('keydown.overlay');
    $(this.selector).find('.js-toggle-overlay').removeClass('slide-out').addClass('slide-in');
    $(this.selector).find('.js-menu-overlay').removeClass('slide-in').addClass('slide-out');

    if ( document.querySelector('html').classList.contains('cart-opened')) {
      document.querySelector('html').classList.remove('cart-opened')
    }

    $(this.selector).css('background-color', '');

    var that = this;
    setTimeout(function() {
      $(that.selector).removeClass('offcanvas-show');
    }, animationTime);
  }

  initToggleAll(){
    let count = 0;

    $(".search-group").each(function(){
      if( !$(this).hasClass("no-collapse") && $(this).is(":visible") ){
        count++;
      }
    });

    if(count > 0){
      $('.js-search-collapse').removeClass('d-none');

      setTimeout(function(){
        $('.js-search-collapse').addClass('show');
      }, 10);
    }
  }

  toggleAll(){

    let that = this;

    $('.side-search-container .collapse_item').each(function(){
      if(that.collapseStatus === 1){
        if(!$(this).hasClass('collapsed')){
          $(this).trigger('click');
        }
      }else{
        if($(this).hasClass('collapsed')){
          $(this).trigger('click');
        }
      }
    });

    this.collapseStatus = (this.collapseStatus === 0) ? 1 : 0;

    $('.js-collapse-text').toggleClass('d-none');
    $('.js-expand-text').toggleClass('d-none');
    $('.js-collapse-icon').toggleClass('d-none');
    $('.js-expand-icon').toggleClass('d-none');
  }

  toggleOne(){

    let total = 0;
    let open = 0;

    $('.collapse_item').each(function(){

      if( !$(this).hasClass("no-collapse") && $(this).is(":visible") ){
        total++;
      }

      if( !$(this).hasClass('collapsed') && $(this).is(":visible") ){
        open++;
      }
    });

    if(total === open){
      $('.js-collapse-text').removeClass('d-none');
      $('.js-expand-text').addClass('d-none');

      $('.js-collapse-icon').removeClass('d-none');
      $('.js-expand-icon').addClass('d-none');

      this.collapseStatus = 1;
    }
    if(open === 0){
      $('.js-collapse-text').addClass('d-none');
      $('.js-expand-text').removeClass('d-none');

      $('.js-collapse-icon').addClass('d-none');
      $('.js-expand-icon').removeClass('d-none');

      this.collapseStatus = 0;
    }
  }

  resetAll(){

    $(this.selector +' .form-control').each(function() {
      $(this).val('').attr('checked', false);
    });
    $(this.selector +' .js-select2').trigger('change.select2');
  }

  desktopClose(){
    $(this.selector).find('.js-menu-overlay').removeClass('slide-in').addClass('slide-out');
    $('.search-bottom').css('white-space', 'nowrap');
    $(this.selector).addClass('desktop-collapse');
    $('.js-desktop-toggle').addClass('hidden');

    $(this.selector).next().css("width", "100%");


    let that = this;
    setTimeout(function(){
      that.collapseStatus = 0;
      that.toggleAll();
    }, 500)

  }

  desktopOpen(){
    $(this.selector)
      .next()
      .css("width", "");

    $(this.selector).removeClass('desktop-collapse');
    $('.js-desktop-toggle').removeClass('hidden');
    $(this.selector).find('.js-menu-overlay').removeClass('slide-out').addClass('slide-in');

    setTimeout(function(){
      $('.search-bottom').css('white-space', '');
    },250);
  }
}


